import { render } from "./RcuUnico.vue?vue&type=template&id=3a544f70&scoped=true"
import script from "./RcuUnico.vue?vue&type=script&lang=js"
export * from "./RcuUnico.vue?vue&type=script&lang=js"

import "./RcuUnico.vue?vue&type=style&index=0&id=3a544f70&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a544f70"]])

export default __exports__